import { environment } from "src/environments/environment";

export const urlServer = environment.api + '';

export const urlPortServices = {
    portAuth : environment.portAuth,
    portHospital : environment.portHospital,
    portUserAdmin : environment.portUserAdmin,
    portGlobalCat : environment.portGlobalCat,
    portPatients : environment.portPatients,
    portHospitalResource : environment.portHospitalResource,
    portProducerKafka : environment.portProducerKafka,
    portConsumerKafka : environment.portConsumerKafka,
    portSchedule : environment.portSchedule,
    portReports : environment.portReports,
    portOperatingRooms: environment.portOperatingRooms,
    portFileSystem: environment.portFileSystem,
}

export const urlServices = {
    urlServiceAuth: urlServer + urlPortServices.portAuth + '/api/authentications/',
    urlServiceHospitalInfra: urlServer + urlPortServices.portHospital + '/api/hospitals-infrastructures/',
    urlServiceUserAdmin: urlServer + urlPortServices.portUserAdmin + '/api/users-administrations/',
    urlServiceGlobalCat: urlServer + urlPortServices.portGlobalCat + '/api/global-catalogs/',
    urlServicePatients: urlServer + urlPortServices.portPatients + '/api/patients-administration/',
    urlServiceHospitalResources: urlServer + urlPortServices.portHospitalResource + '/api/hospitals-resources/',
    urlServiceProducerKafka: urlServer + urlPortServices.portProducerKafka + '/api/producer-service/',
    urlServiceConsumerKafka: urlServer + urlPortServices.portConsumerKafka + '/api/consumer-service/',
    urlServiceScheduleInfra: urlServer + urlPortServices.portSchedule + '/api/schedule-infrastructures/',
    urlServiceReportsCore: urlServer + urlPortServices.portReports + '/api/reports-core/',
    urlServiceOperatingRooms: urlServer + urlPortServices.portOperatingRooms + '/api/operating-rooms/',
    urlServiceFileSystem: urlServer + urlPortServices.portFileSystem + '/api/file-system/'
};
